"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxGet = ajaxGet;
exports.ajaxGetWithExceptionHandler = ajaxGetWithExceptionHandler;
exports.ajaxPost = ajaxPost;
exports.ajaxPostJson = ajaxPostJson;
exports.ajaxPostWithExceptionHandler = ajaxPostWithExceptionHandler;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function getParamString(data) {
  if ((0, _typeof2.default)(data) === 'object') {
    var paramString = '';
    Object.keys(data).forEach(function (key) {
      paramString += "&".concat(key, "=").concat(data[key]);
    });
    return paramString.substr(1);
  } else {
    return data || '';
  }
}
function ajaxPost(url, paramString) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          resolve(response);
        }
      } else {
        reject(new Error(xhr.statusText));
      }
    };
    xhr.send(getParamString(paramString));
  });
}
function ajaxPostJson(url, payload) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('content-type', 'application/json;charset=UTF-8');
    xhr.onload = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          resolve(response);
        }
      } else {
        reject(new Error(xhr.statusText));
      }
    };
    xhr.send(JSON.stringify(payload));
  });
}
function ajaxGet(url, paramString) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('Get', url + '?' + getParamString(paramString), true);
    //xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          resolve(response);
        }
      } else {
        reject(new Error(xhr.statusText));
      }
    };
    xhr.send();
  });
}
function ajaxPostWithExceptionHandler(url, paramString, exceptionHandler, options) {
  return new Promise(function (resolve, reject) {
    var header = 'application/x-www-form-urlencoded';
    if (options) {
      if (options.header) {
        header = options.header;
      }
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('content-type', header);
    xhr.onload = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          resolve(response);
        } else {
          if (exceptionHandler) {
            exceptionHandler(xhr.status);
          }
        }
      } else {
        reject(new Error(xhr.statusText));
      }
    };
    xhr.send(getParamString(paramString));
  });
}
function ajaxGetWithExceptionHandler(url, paramString, exceptionHandler) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('Get', url + '?' + getParamString(paramString), true);
    //xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          resolve(response);
        } else {
          if (exceptionHandler) {
            exceptionHandler(xhr.status);
          }
        }
      } else {
        reject(new Error(xhr.statusText));
      }
    };
    xhr.send();
  });
}